import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-viewer--youtube",
  id: "player"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Poxa, Houve um erro ao carregar o conteúdo.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentAlertModal = _resolveComponent("ContentAlertModal")!
  const _component_ContentFallback = _resolveComponent("ContentFallback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ContentAlertModal, {
      width: "100%",
      onCloseContentAlertModal: _ctx.onCloseSeekModal,
      text: "Opa! Você precisa assistir todo o conteúdo para conseguir concluir o treinamento."
    }, null, 8, ["onCloseContentAlertModal"]), [
      [_vShow, _ctx.didShowSeekerModal]
    ]),
    (_ctx.isYouTubeRendered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createBlock(_component_ContentFallback, {
          key: 1,
          class: "content-viewer--youtube"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }))
  ], 64))
}